import React, { useState, useEffect, useCallback } from "react"
import CheckImg from "assets/images/check.svg"
import { debounce } from "lodash"
import pic1 from "assets/images/home/hero-event.png"
import next from "assets/images/next.svg"
import previous from "assets/images/previous.svg"
import DeleteModal from "components/Common/DeleteModal"
import { get, del } from "api/axios"
import endpoints from "api/endpoints"
import { toast } from "react-toastify"
import { Link } from "react-router-dom"
import Paginations from "components/Common/Paginations/Paginations"
import ShowingCount from "components/Common/Paginations/ShowingCount"
import {
  Container,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Alert,
} from "reactstrap"
import BlockedUsersTable from "pages/BlockedUsers/components/myTable"

export default function ListCoupon() {
  const [show, setShow] = useState(false)
  const [coupons, setCoupons] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [searchItem, setSearchItem] = useState("")

  const [selectedCoupon, setSelectedCoupon] = useState("")

  const toggleModal = () => {
    setShow(!show)
  }
  const handleDelete = async () => {
    try {
      const resp = await del(`${endpoints.coupon}/${selectedCoupon}`).then(
        () => {
          toast.success("Coupon Deleted Successfully", {
            position: "bottom-center",
            theme: "colored",
          })
          getFetch()
          toggleModal()
        }
      )
    } catch (e) {}
  }
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [filter, setFilter] = useState({
    action: "lastMonth",
    text: "Last Month",
  })
  const toggle = () => setDropdownOpen(prevState => !prevState)

  const [startIndex, setStartIndex] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(5)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [count, setCount] = useState(0)
  const getFetch = useCallback(async () => {
    const resp = await get(
      `${endpoints.coupon}?page=${startIndex}&limit=${itemsPerPage}&pagination=true&search=${searchItem}&filter=${filter?.action}`
    )

    if (resp?.data?.success) {
      setCoupons(resp?.data?.data)
      setTotalPages(Math.ceil(resp?.data?.totalPages))
      setCount(Math.ceil(resp?.data?.count))
    }
  }, [startIndex, itemsPerPage, searchItem, filter])
  const debouncedSearch = useCallback(
    debounce(term => {
      setSearchItem(term)

      // Call your search function or API here
    }, 500), // 300ms delay
    []
  )

  const handleChange = e => {
    setSearchTerm(e.target.value)
    debouncedSearch(e.target.value)
  }
  useEffect(() => {
    setStartIndex(currentPage)
  }, [currentPage, itemsPerPage])

  useEffect(() => {
    getFetch()
  }, [startIndex, itemsPerPage, getFetch, filter])

  return (
    <section id="coupons-list" className="page-content bg-light">
      <DeleteModal
        show={show}
        onCloseClick={toggleModal}
        onDeleteClick={handleDelete}
      />
      <Container fluid className="margin-video-vaults">
        <h2 className=" d-flex flex-column flex-md-row text-dark font-size-26 font-weight-semibold ff-barlow text-uppercase d-flex justify-content-between">
          <div className="d-flex justify-content-start align-items-center">
            Coupon
            <span className="  p-2   mx-3 filter-btn d-flex justify-content-between align-items-center ">
              <Input
                type="text"
                name="search"
                className="hover-input"
                placeholder="Search"
                value={searchTerm}
                onChange={handleChange}
              />
            </span>
          </div>
          <div className="d-flex justify-content-end align-items-center mt-3 mt-md-0">
            <Link to="/add-coupon">
              <button className="btn btn-primary-green text-uppercase ms-3">
                add new coupon
              </button>
            </Link>
          </div>
        </h2>

        <div className="overflow-auto card shadow p-3 rounded-4 mt-3">
          <table className="table">
            <thead>
              <tr className="my-2 text-uppercase">
                <th
                  scope="col"
                  className="font-size-14 fw-medium text-darkcolor"
                >
                  #ID{" "}
                </th>
                <th scope="col" className="font-size-14 text-darkcolor">
                  Coupon Code
                </th>
                <th scope="col" className="font-size-14 text-darkcolor">
                  Coupon Type
                </th>
                <th scope="col" className="font-size-14 text-darkcolor">
                  description
                </th>
                <th scope="col" className="font-size-14 text-darkcolor">
                  Added On
                </th>
                <th scope="col" className="font-size-14 text-darkcolor">
                  Last Updated On
                </th>
                <th scope="col" className="font-size-14 text-darkcolor ">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="align-middle">
              {coupons.length > 0 ? (
                coupons.map((coupon, index) => (
                  <tr key={coupon.id}>
                    <td className="text-secondary fw-normal font-size-16">
                      {index + 1 + (currentPage - 1) * itemsPerPage}
                    </td>
                    <td className="text-secondary fw-normal font-size-16">
                      {coupon.discountCode}
                    </td>{" "}
                    <td className="text-secondary text-uppercase fw-normal font-size-16">
                      {coupon.discountCodeType}
                    </td>
                    <td className="text-secondary  fw-normal font-size-16">
                      {coupon.description.substring(0, 20)}...
                    </td>
                    <td className="text-secondary fw-normal font-size-16">
                      {new Date(coupon.createdAt).toLocaleDateString()}
                    </td>
                    <td className="text-secondary fw-normal font-size-16">
                      {new Date(coupon.updatedAt).toLocaleDateString()}
                    </td>
                    <td scope="col" className="">
                      <div className="d-flex gap-2 ">
                        {/* <Link to={`/edit-coupon/${coupon?._id}`}>
                          <button className="btn btn-link p-0">
                            <i className="fa-light fa-edit text-secondary font-size-16" />
                          </button>
                        </Link> */}

                        <button
                          className="btn btn-link p-0"
                          onClick={e => {
                            toggleModal()
                            setSelectedCoupon(coupon?._id)
                          }}
                        >
                          <i className="fa-light fa-trash gray-700 font-size-16" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center">
                    <Alert className="text-center">No Record Found!</Alert>{" "}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <ShowingCount
            currentPage={currentPage}
            count={count}
            itemsPerPage={itemsPerPage}
          />
          <Paginations
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      </Container>
    </section>
  )
}
